import { useEffect } from 'react';

export default function useDynamicManifest() {
	useEffect(() => {
		const manifestTag = document.querySelector<HTMLLinkElement>('#dynamic-manifest');

		const updateManifest = (scheme: 'light' | 'dark') => {
			if (manifestTag) {
				manifestTag.href = `/manifest-${scheme}.json`;
			}

			//! Optional: Set <meta name="theme-color">
			const themeMeta = document.querySelector('meta[name="theme-color"]');
			if (themeMeta) {
				themeMeta.setAttribute('content', scheme === 'dark' ? '#000000' : '#ffffff');
			}
		};

		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
		const handleChange = (e: MediaQueryListEvent) => updateManifest(e.matches ? 'dark' : 'light');

		updateManifest(mediaQuery.matches ? 'dark' : 'light');
		mediaQuery.addEventListener('change', handleChange);

		return () => {
			mediaQuery.removeEventListener('change', handleChange);
		};
	}, []);
}
